<app-navbar></app-navbar>
<div class="login-container">
  <div class="login-card">
    <img class="logo" src="assets/images/logo.png" alt="Logo" />
    <p>Connexion</p>

    <div class="field">
        <input id="username" placeholder="Adresse email" type="text" [(ngModel)]="email" />
    </div>
    <div class="field">
        <input id="password" placeholder="Mot de passe" type="password" [(ngModel)]="password" />
    </div>
    <div class="field">
      <button *ngIf="!isLoading" type="button" (click)="login()">Se Connecter</button>
      <mat-progress-spinner
        *ngIf="isLoading"
        mode="indeterminate"
        diameter="40"
        class="spinner">
      </mat-progress-spinner>
    </div>
  </div>
</div>
